<template>
  <b-modal id="viewDataModal" size="lg">
    <div slot="modal-header">
      <h2>{{ $t(`template.preview_${name}`) }}</h2>
    </div>

    <div slot="modal-footer" class="justify-end">
      <button class="bttn bttn--lg bttn--blue" @click.prevent="closeModal">Cancel</button>
    </div>

    <b-alert show variant="warning" class="w-100">
      {{ $t(`template.preview_donations_text`) }}
      <router-link to="/dashboard">{{ $t(`template.dashboard`) }}</router-link>
    </b-alert>

    <div class="data-view" v-for="[key, value] in dataViewEntries" :key="key">
      <div class="data-view__title">
        {{ $t("template." + key, getDefaultTranslate(key)) }}
      </div>
      <div class="data-view__data">
        {{ value ? setValueFormat(value, key) : $t("template.empty_key", "-") }}
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment-timezone";

import { mapState } from "vuex";

export default {
  props: {
    name: {
      type: String,
      defaults: "",
    },
  },

  data() {
    return {
      dataView: null,
    };
  },

  computed: {
    ...mapState({
      timeZone: (state) => {
        return state.account.account.data.attributes.timezone;
      },
    }),

    dataViewEntries() {
      return Object.entries(this.dataView || {}).filter(([k]) => this.checkAvailable(k));
    },

    defaultTranslate() {
      return {
        account: "Account",
        bank: "Bank",
        bank_name: "Gateway",
        bank_name_label: "Gateway label",
        billing_last_name: "Last Name",
        billing_name: "First Name",
        branch: "Branch",
        campaign_name: "Campaign",
        can_be_canceled: "Can be canceled",
        can_generate_receipt: "Can generate receipt",
        captured: "Captured",
        category: "Category",
        change_request_note: "Change request note",
        change_request_type: "Change request type",
        charged_amount: "Charged amount",
        check_n: "Check n",
        created_by: "Created by",
        currency_code: "Currency code",
        customer_id: "Customer id",
        date: "Date",
        dedication: "Dedication",
        display_name: "Display name",
        effective_amount: "Effective amount",
        email: "Email",
        failure_reason: "Failure reason",
        fee_cover_amount: "Fee cover amount",
        get_data: "Get data",
        installments_n: "Installments n",
        lead_status: "Lead status",
        legal_entity_id: "Legal entity id",
        locked: "Locked",
        locked_type: "Locked type",
        locked_var_int: "Locked var int",
        mark_canceled_donation_id: "Mark canceled donation id",
        matched_donation_id: "Matched donation id",
        module_data_id: "Module data id",
        offline_donation_note: "Offline donation note",
        offline_donation_source: "Offline donation source",
        org_comment: "Org comment",
        payment_address: "Payment address",
        payment_address_2: "Payment address 2",
        payment_city: "Payment city",
        payment_country: "Payment country",
        payment_postcode: "Payment postcode",
        payment_state: "Payment state",
        peer_matched_by_donation_id: "Peer matched by donation id",
        peer_matched_donation_id: "Peer matched donation id",
        phone: "Phone",
        pledge_notification_to_pay_sent: "Pledge notification to pay sent",
        pledge_with_notification_to_pay: "Pledge with notification to pay",
        processing_charged_amount: "Processing charged_amount",
        processing_charged_currency: "Processing charged_currency",
        receipt_name: "Receipt name",
        recurring_canceled: "Recurring canceled",
        recurring_canceled_by: "Recurring canceled by",
        recurring_paid_off: "Recurring paid off",
        recurring_period: "Recurring period",
        referrer: "Referrer",
        send_confirmation_email: "Send confirmation email",
        send_receipt: "Send receipt",
        send_receipt_without_pdf_receipt_attached: "Send receipt without pdf receipt attached",
        status: "Status",
        stream_id: "Stream id",
        sub_duration: "Sub duration",
        sub_duration_type: "Sub duration type",
        sub_type: "Sub type",
        tag: "Tag",
        team_id: "Team id",
        team_id_list: "Team id list",
        transaction_id: "Transaction id",
      };
    },
  },

  methods: {
    getDefaultTranslate(key) {
      return this.defaultTranslate?.[key] || "";
    },
    setValueFormat(data, key) {
      if (key === "date") {
        return moment.tz(data * 1000, this.timeZone).format("YYYY-MM-DD HH:mm");
      } else if (
        key === "charged_amount" ||
        key === "effective_amount" ||
        key === "processing_charged_amount"
      ) {
        return data.toLocaleString();
      } else if (key === "currency_code" || key === "processing_charged_currency") {
        return data.toUpperCase();
      } else {
        return data;
      }
    },

    openModal(data) {
      this.dataView = data;
      this.$store.dispatch("getTeamsByCampaignId", [data.campaign_id]);
      this.$root.$emit("bv::show::modal", "viewDataModal");
    },

    closeModal() {
      this.dataView = null;
      this.$root.$emit("bv::hide::modal", "viewDataModal");
    },

    checkAvailable(key) {
      const disabledKeys = [
        "campaign_id",
        "donation_receipt_id",
        "moderation_status",
        "donation_type",
        "currency_sign",
      ];

      return !disabledKeys.includes(key);
    },
  },
};
</script>

<style lang="scss">
.data-view {
  margin-bottom: 20px;
  border-bottom: 1px solid lightgrey;
  display: flex;
  flex-wrap: wrap;
  &:last-child {
    border-bottom: 0;
  }
  @media only screen and (min-width: 992px) {
    flex-wrap: nowrap;
  }
  &__title {
    min-width: 100%;
    padding: 10px 0;
    font-family: "ProximaNova-Bold", sans-serif;
    font-size: 16px;
    @media only screen and (min-width: 992px) {
      min-width: 30%;
      max-width: 30%;
      margin-right: 20px;
    }
  }
  &__data {
    flex-grow: 1;
    padding: 10px 0;
    //font-family: 'ProximaNova', sans-serif;
    font-size: 16px;
    word-wrap: break-word;
    max-width: 65%;
  }
}

#viewDataModal {
  .justify-end {
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .data-view__data {
    max-width: 100%;
  }
}
</style>
